import { render, staticRenderFns } from "./ModuleMessageSign.vue?vue&type=template&id=74e15494&scoped=true&"
import script from "./ModuleMessageSign.vue?vue&type=script&lang=js&"
export * from "./ModuleMessageSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e15494",
  null
  
)

export default component.exports